import React from "react";
import { useTranslation } from 'react-i18next';

export default function SelectParkingZone(props) {  
    const { t } = useTranslation();  
    return(         
        <div className="limiter">
            <div className="container h-vh pl-0 pr-0">
                <div className="col-md-7 pl-0 pr-0">
                    <div className="pass-container">
                        <div className="logo-container text-center mt-2 mb-4">
                            <div className="text-right">
                                <button type="button" className="btn btn-secondary text-uppercase" onClick={props.logout}>Logout</button>
                            </div>
                            <img src={require('../assets/images/logo_white.svg')} alt=""/>
                        </div>
                        {!props.zoneQuery && <div>
                            <h2 className="visitor-heading text-center">{props.sheetData.Visitor} <span>{props.sheetData.Pass}</span></h2>
                            <p>
                                {props.sheetData.RequiredFieldsPartA} (<span>*</span>) {props.sheetData.RequiredFieldsPartB}
                            </p>
                            {props.submitted === true && props.visitorPassResponse && props.visitorPassResponse.ipark_out.r !== '1' && <div className="alert alert-danger">
                                Some error occured while registration, please try again.
                            </div>}
                            {props.purchasedConsecutive === true && <div className="alert alert-danger">
                                {props.sheetData.purchasedThreeTimes}
                            </div>}
                        </div>}
                        {props.zoneQuery && <div className="text-white text-center">
                            {/* <h2 className="visitor-heading text-center">{props.sheetData.Visitor} <span>{props.sheetData.Pass}</span></h2> */}
                            <h2>{props.sheetData.RegisterForFreeLabel} {props.freeHours} {props.sheetData.FreeParking}</h2>
                            {props.purchasedConsecutive === true && <div className="alert alert-danger">
                                {props.sheetData.purchasedThreeTimes}
                            </div>}
                            <hr></hr>
                            {props.sheetData.ZoneName} <strong>{props.currentZone[0].name}</strong>
                        </div>}
                        <br></br>
                        <div  className="login100-form validate-form">
                            {!props.zoneQuery && <div className="form-group">
                                <label>{props.sheetData.ParkingZone} <span>*</span></label>                            
                                <select id="zone" name="zone" size="1" className="form-control" onChange={(e)=>{props.onZoneChange(e.target.value)}} required>
                                    {Object.keys(props.zoneList).map((prop, key) => {                                        
                                        return (
                                            <option key = {key} value={props.zoneList[prop].id}>
                                                {props.zoneList[prop].name}
                                            </option>
                                        )
                                    })}
                                </select>
                            </div>}
                            <div>
                                <div className="form-group mb-0">
                                    <label>{props.sheetData.ParkingOptions} <span>*</span></label>
                                </div>
                                {props.option.map(x=>{
                                    console.log(x)
                                    return(
                                        <div className="row mx-2" key={x.id}>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id={x.id} name="parkingOption"
                                                value={x.id} checked={x.optionCode == props.formData['parkingOption'] || props.formData['parkingOption'] == ''} 
                                                onChange={(e)=>{props.handleChange(e)}} required></input>
                                                <label className="form-check-label" htmlFor={x.id}>{x.name}</label>                        
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="form-group" style={{marginTop:'20px'}}>
                                <label>{props.sheetData.EnterYourPlate} <span>*</span></label>                            
                                {!props.zoneQuery && <div>
                                    <input type="text" className="form-control text-uppercase" placeholder={props.sheetData.PlateNumber}
                                    name="PlateNo" value={props.formData['PlateNo']} onChange={(e)=>{props.handleChange(e)}} required></input>
                                    {props.formData.PlateNo !== "" && props.formData.PlateNo !== undefined && <button className="clear-icon" onClick={()=>props.clearPlateNo()}>X</button>}
                                    {props.formData.PlateNo == "" && <div style={{color:'white'}}>
                                        <div> {props.sheetData.PlateRequired} </div>
                                    </div>}
                                </div>}
                                {props.zoneQuery &&<div>
                                    <input type="text" className="form-control text-uppercase" placeholder={props.sheetData.PlateNumber}
                                    name="PlateNo" value={props.formData['PlateNo']} onChange={(e)=>{props.handleChange(e)}} autoFocus required></input>
                                    {props.formData.PlateNo !== "" && props.formData.PlateNo !== undefined && <button className="clear-icon" onClick={()=>props.clearPlateNo()}>X</button>}
                                    {props.formData.PlateNo == "" && <div  style={{color:'white'}}>
                                        <div> {props.sheetData.PlateRequired} </div>
                                    </div>}
                                </div>}
                            </div>
                            {!props.zoneQuery && <div>
                                <button type="button"className="btn btn-primary text-uppercase" disabled = {props.formData.PlateNo == null || props.formData.PlateNo == '' || props.formData.parkingOption == null} onClick = {()=>{props.onSubmit()}}>{props.sheetData.Submit}</button>
                                <button type="button" className="btn btn-info text-uppercase ml-2" onClick= {()=>{props.resetForm()}}>{props.sheetData.Clear}</button>  

                            </div>}
                            {props.zoneQuery &&<div>
                                <button type="button"className="btn btn-primary text-uppercase" disabled = {props.formData.PlateNo == null || props.formData.PlateNo == ''} onClick = {()=>{props.onSubmit()}}>{props.sheetData.Submit}</button>                        
                            </div>}
                        </div>
                        <div className="copyright mt-5 text-center text-uppercase"><a href = "https://blinkay.com/">© Blinkay</a> {(new Date().getFullYear())}. {props.sheetData.AllRightReserved}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}